import { getWishlistStorage } from '@jsmdg/browser-storage';
export var getAnonymousWishlist = function () {
    var wishlistStorage = getWishlistStorage();
    return wishlistStorage.get();
};
//# sourceMappingURL=getAnonymousWishlist.js.map